export default (appName: string, env: string) => {
    let versionText = `${appName} version: `;

    const version = import.meta.env.VITE_APP_VERSION || '';
    const commitHash = import.meta.env.VITE_GIT_COMMIT_HASH || '';
    const branch = env === 'staging' ? import.meta.env.VITE_GIT_BRANCH + ' ' : '';
    versionText += version;

    if (commitHash) {
        versionText += ` (${branch}${commitHash})`;
    }

    return versionText;
};
